import React from 'react';
import { useNavigate } from 'react-router-dom';

import Tabs from 'components/Tabs';

import './index.css';

interface Props {
    studentOrganizationId: string | number;
    active: 'commonapp' | 'essays' | 'colleges';
}

// Tab switcher shown on a student's FillApp pages: Common App practice form
// (/fillapp/review/:id), AI Essay Review (/fillapp/essays/:id), and the
// student's college list (/fillapp/colleges/:id). Reached via the single
// "Review" action on the roster. Uses the shared Tabs component so the style
// matches tabs elsewhere in the app.
function FillAppTabs({ studentOrganizationId, active }: Props) {
    const navigate = useNavigate();
    const paths = [
        `/college-apps/review/${studentOrganizationId}`,
        `/college-apps/essays/${studentOrganizationId}`,
        `/college-apps/colleges/${studentOrganizationId}`,
    ];
    const activeIndex = active === 'essays' ? 1 : active === 'colleges' ? 2 : 0;
    return (
        <Tabs
            className='fillAppTabs'
            tabs={['Common App', 'Essays', 'Colleges']}
            tabIndex={activeIndex}
            onSelect={paths.map((path, i) => () => { if (i !== activeIndex) navigate(path); })}
        />
    );
}

export default FillAppTabs;
